/**
 * Thin wrapper over Meta Pixel and GA4.
 *
 * Both are opt-in: if the corresponding env var is unset the helpers below are
 * no-ops, so the site runs identically with no tracking configured.
 */

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    gtag?: (...args: unknown[]) => void;
  }
}

export const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID ?? "";
export const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_ID ?? "";

export const hasMetaPixel = Boolean(META_PIXEL_ID);
export const hasGoogleAnalytics = Boolean(GA_MEASUREMENT_ID);
export const hasAnalytics = hasMetaPixel || hasGoogleAnalytics;

type Params = Record<string, string | number | boolean | undefined>;

/** Meta standard event (Lead, Contact, ViewContent, …) plus the GA4 mirror. */
export function trackEvent(name: string, params: Params = {}): void {
  if (typeof window === "undefined") return;

  window.fbq?.("track", name, params);
  window.gtag?.("event", name, params);
}

/** Fired once a service request or consultation booking is stored. */
export function trackLead(params: Params = {}): void {
  trackEvent("Lead", { content_category: "booking", ...params });
}

/** Fired when a visitor opens a case study. */
export function trackViewContent(params: Params = {}): void {
  trackEvent("ViewContent", params);
}

/** Fired when a visitor starts the request flow from a service card. */
export function trackInitiateCheckout(params: Params = {}): void {
  trackEvent("InitiateCheckout", params);
}
